import { IntlShape } from 'react-intl';
import { ReactComponent as IconExit } from '@whitelabel/media/icons/small/exit.svg';
import { ReactComponent as IconArrowLeft } from '@whitelabel/media/icons/small/arrow-left.svg';
import messages from '@whitelabel/rentalcover-shared/helpers/messages/commonMsg';
import { isRCAffiliateLink } from '@whitelabel/rentalcover-shared/helpers/site';

export interface INavParent {
  key: string;
  name: string;
  children: INavParent[] | INavLink[];
}

export interface INavLink {
  key: string;
  name: string;
  href: string;
}

export const isNavParent = (nav: INavParent | INavLink): nav is INavParent =>
  (nav as INavParent).children !== undefined;

export const isNavLink = (nav: INavParent | INavLink): nav is INavLink => (nav as INavLink).href !== undefined;

export const isPathActive = (currentPath: string, itemPath: string): boolean =>
  currentPath === itemPath || currentPath.startsWith(`${itemPath}/`);

export const protectionLink = (intl: IntlShape) => ({
  key: 'protection',
  messageKey: 'yourProtection',
  path: isRCAffiliateLink() ? '/protection' : '/account',
  name: intl.formatMessage(messages.yourProtectionLinkText),
  'data-test-id': 'nav-item-protection',
});

export const profileLink = (intl: IntlShape) => ({
  key: 'profile',
  messageKey: 'yourProfile',
  path: '/account/profile',
  name: intl.formatMessage(messages.yourProfileLinkText),
  'data-test-id': 'nav-item-profile',
});

export const claimsLink = (intl: IntlShape) => ({
  key: 'claims',
  messageKey: 'yourClaims',
  path: '/claims',
  name: intl.formatMessage(messages.yourClaimsLinkText),
  'data-test-id': 'nav-item-claims',
});

export const offersLink = (intl: IntlShape) => ({
  key: 'offers',
  messageKey: 'yourOffers',
  path: '/account/offers',
  name: intl.formatMessage(messages.yourOffersLinkText),
  extraLabel: intl.formatMessage(messages.yourOffersExtraLabel),
  'data-test-id': 'nav-item-offers',
});

export const claimDetailsLink = (intl: IntlShape, claimReference: string) => ({
  key: 'claimDetails',
  messageKey: 'yourClaimDetails',
  path: `/claims/${claimReference}/details`,
  name: intl.formatMessage(messages.yourClaimsLinkText),
  icon: IconArrowLeft,
  'data-test-id': 'nav-item-claim-details',
});

export const logoutLink = (intl: IntlShape) => ({
  key: 'logout',
  messageKey: 'logout',
  path: '/logout-customer',
  dataAnalytics: 'page.navbar.btn.logout',
  icon: IconExit,
  name: intl.formatMessage(messages.logoutLinkText),
  'data-test-id': 'nav-item-logout',
});
